import React, {Fragment, useEffect, useState, useMemo} from 'react';
import {connect} from 'react-redux';
import {injectIntl} from '@s7ui-kit/s7ui-kit';
import isEmpty from "lodash/isEmpty";
import isUndefined from 'lodash/isUndefined';

import requestUtil from "../../../services/services/requestUtil";
import pushGA from "../../../services/utils/pushGA";
import Card from '../../../components/common/Card/Card';
import HorizontalScroll from '../../common/HorizontalScroll/HorizontalScroll';
import { Section } from '../../main/Section';
import {
    analyticsMainPageBlockClick,
    analyticsMainPageBlockLoaded,
    analyticsMainPageBlockShown
} from '../../../services/analytics/analyticsMainpage';

import '../new-mainpage/news-block.scss';

const mapStateToProps = ({App, User}) => ({App, User});

const contentServicePrefix = `${process.env.REACT_APP_PREFIX_CONTENT_SERVICE}/api/v1`;

const NewsBlock = (props) => {
    const {App: {lang}} = props;
    const { words, getMessage } = props;

    const [ gotNews, setGotNews ] = useState(false);
    const [ news, setNews ] = useState([]);
    const [ shownPriorityNewsNumber, setShownPriorityNewsNumber ] = useState(0);

    const ecomParamsForGA = useMemo(() => {
        return news.map((item, index) => {
            return {
                item_id: item.code,
                item_name: 'news',
                affiliation: 'content',
                index: index + 1,
                location_id: 's7_main'
            }
        })
    }, [ news ]);

    useEffect(() => {
        getMessage(words, 'com.s7.main.page.all.news');

        const s7PageInit = typeof(window.s7PageInit)!=='undefined' ? window.s7PageInit : {};

        if(s7PageInit.hasOwnProperty('mainPageNews') && s7PageInit.mainPageNews.hasOwnProperty(lang)){
            setNews(s7PageInit.mainPageNews[lang]);
            setGotNews(true);
        } else {

            const limit = 3;

            const searchParams = new URLSearchParams('');
            searchParams.append('lang', lang);
            searchParams.append('offset', shownPriorityNewsNumber);
            searchParams.append('limit', limit);
            searchParams.append('s7Priority', false);

            requestUtil(`${contentServicePrefix}/content/news?${searchParams}`)
                .then(response => {
                    if (response.items && response.items.length > 0) {
                        setNews(response.items);
                        setGotNews(true);
                    } else {
                        setGotNews(false);
                    }
                }).catch((e) => {
                setGotNews(false);
                throw new Error(e);
            });
        }

    }, []);

    useEffect(()=> {
        if(!gotNews){
            return;
        }
        analyticsMainPageBlockLoaded({
            step: 'news',
            items: ecomParamsForGA
        });
    }, [gotNews]);

    const inView = () => {
        const { App: { deviceWidth } } = props;
        setTimeout(()=> {
            analyticsMainPageBlockShown({
                step: 'news',
                items: ecomParamsForGA,
                ux: deviceWidth < 768 ? 'carousel': 'auto_open'
            })
        }, 2000);
    };

    const onClickArticle = index => {
        analyticsMainPageBlockClick({
            step: 'news',
            items: [ecomParamsForGA[index]]
        })
    };

    const onClickShowMore = () => {
        analyticsMainPageBlockClick({
            step: 'news',
            items: [{
                item_id: 'all',
                item_name: 'news',
                affiliation: 'content',
                index: undefined,
                location_id: 's7_main'
            }]
        })
    };

    const renderNewsItems = () => {
        const { App: { deviceWidth } } = props;

        if ( !isEmpty(news) && Array.isArray(news.items) && !isEmpty(news.items) ) {
            return;
        }

        return deviceWidth > 767 ? <Fragment>
            {news.map((item,index) => (
                <Card
                    key={`news-${item.id}`}
                    item={ setCommonItem(item) }
                    gaName='NewsMain'
                    itemClass={'news-block-holder-item'}
                    onClick={() => onClickArticle(index)}
                />
            ))}
        </Fragment>
        :
        <HorizontalScroll>
            {news.map((item,index) => (
                <div className={'news-block-mobile-item'}  key={`news-${item.id}-container`}>
                    <Card
                        key={`news-${item.id}`}
                        item={ setCommonItem(item) }
                        gaName='NewsMain'
                        itemClass={'news-block-holder-item'}
                        onClick={() => onClickArticle(index)}
                    />
                </div>
            ))}
        </HorizontalScroll>

    };

    const setCommonItem = item => {

        return {
            title: item.title,
            date: item.date,
            image: item.thumbnail || '6d387426-43aa-41cd-adae-13cb64315529',
            identifier: item.id,
            description: item.description ? item.description : ' ',
            hideTitle: !isUndefined(item.titleOptions) && item.titleOptions.includes('HIDDEN_IN_LIST'),
            code: `/${lang}/news/${item.code}`
        };
    };

    if(!gotNews){
        return null;
    }

    return (<Section
        title={getMessage(words, 'com.s7.main.page.all.news.title')}
        className={'news-block'}
        onClick={()=>{
            onClickShowMore();
            pushGA('PORTAL NewsMain',
                'Click_GoToPortal',
                `https://${window.location.hostname}/${lang}/news`,
                {eventValue: 0,
                    eventUX: 'link',
                    eventInteraction: 0
                });
        }}
        link={`https://${window.location.hostname}/${lang}/news`}
        text={getMessage(words, 'com.s7.main.page.section.news.show.all')}
        inView={inView}
    >
        <div className={'news-block-holder'}>
            { renderNewsItems() }
        </div>
    </Section>);
};


export default injectIntl(connect(mapStateToProps)(React.memo(NewsBlock)));